import * as React from 'react';
import b_ from 'b_';
import { BaseFieldProps, Field, WrappedFieldProps } from 'redux-form';
import { InputView, Props as InputViewProps } from '../InputView';
import { Eye } from './Eye';

import './index.scss';

const b = b_.with('password-field');

type Props = Omit<InputViewProps, 'type'>;

const PasswordInputView: React.FC<Props & WrappedFieldProps> = (props) => {
  const [isPlainText, toggle] = React.useState(false);

  return (
    <InputView
      {...props}
      type={isPlainText ? 'text' : 'password'}
      inside={
        <Eye
          className={b('eye')}
          isPlainText={isPlainText}
          onClick={() => toggle((isPlainText) => !isPlainText)}
        />
      }
    />
  );
};

export const PasswordInput: React.FC<BaseFieldProps & Props> = (props) => (
  <Field component={PasswordInputView} {...props} />
);
